/**
 * Utilities for image styling - shapes, rotation, and sizing.
 * 
 * Since we use server-side cropping, this module no longer handles crop CSS.
 * The actual cropping is done server-side and served via cropped_image_url.
 */



/**
 * Get shape-specific CSS styles based on image format.
 */
export function getShapeStyles(format) {
  const IMAGE_FORMAT_STYLES = {
  // Use a dynamic circle mask that retains a true circle based on the shorter side
  // var(--circle-radius) should equal min(width, height)/2 in px, computed at runtime
  // Fallback to a very large radius so initial paint is not invisible before JS computes it
  circle: { clipPath: "circle(var(--circle-radius, 9999px) at 50% 50%)" },
    oval: { borderRadius: "50% / 25%" },
    diamond: { clipPath: "polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)" },
    hexagon: {
      clipPath: "polygon(25% 6.7%, 75% 6.7%, 100% 50%, 75% 93.3%, 25% 93.3%, 0% 50%)",
    },
    triangle: { clipPath: "polygon(50% 0%, 0% 100%, 100% 100%)" },
    star: {
      clipPath: "polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)",
    },
    // Use a dynamic clip-path that relies on CSS custom properties set at runtime.
    // This masks the visible area to a centered square without changing layout size.
    square: { clipPath: "inset(var(--square-top, 0%) var(--square-right, 0%) var(--square-bottom, 0%) var(--square-left, 0%))" },
    original: {}
  };
  
  return IMAGE_FORMAT_STYLES[format] || {};
}


